import { getDefaultHeight, SVG } from "./utils";

type Props = {
  color?: string;
} & React.SVGProps<SVGSVGElement>;

export const CircledPlayIcon: React.FC<Props> = ({ color, ...svgProps }) => {
  return (
    <SVG
      viewBox="0 0 39 39"
      xmlns="http://www.w3.org/2000/svg"
      height={getDefaultHeight(svgProps, 39)}
      {...svgProps}
    >
      <path
        d="m26.87 18.62a1 1 0 0 1 0 1.76l-9.9 5.33a1 1 0 0 1 -1.47-.88v-10.66a1 1 0 0 1 1.47-.88z"
        fill={color ?? "currentColor"}
      />
      <g fill="none" stroke={color ?? "currentColor"} strokeWidth="2">
        <circle cx="19.5" cy="19.5" r="19.5" stroke="none" />
        <circle cx="19.5" cy="19.5" r="18.5" />
      </g>
    </SVG>
  );
};
